export default () => {
  const languagePicker = document.querySelectorAll(".js-language-picker");
  const languagePickerToggle = document.querySelectorAll(".js-language-picker-toggle");
  const languagePickerList = document.querySelectorAll(".js-language-picker-list");

  if (!languagePicker) {
    return;
  }

  for (let i = 0; i < languagePickerToggle.length; i++) {
    languagePickerToggle[i].addEventListener("click", () => {
      languagePickerToggle[i].classList.toggle("is-active");
      languagePickerList[i].classList.toggle("is-open");
    });

    document.addEventListener("click", (event) => {
      if (!languagePickerToggle[i].contains(event.target as Node) && !languagePickerList[i].contains(event.target as Node)) {
        languagePickerToggle[i].classList.remove("is-active");
        languagePickerList[i].classList.remove("is-open");
      }
    });
  }
}
